import VueJwtDecode from 'vue-jwt-decode';

const storedTestatorId = () => {
  const value = localStorage.getItem('testatorId');
  return value && value !== 'null' && value !== 'undefined' ? value : null;
};

export default {
  state: {
    accessToken: localStorage.getItem('accessToken') || null,
    refreshToken: localStorage.getItem('refreshToken') || null,
    testatorId: storedTestatorId(),
    userId: localStorage.getItem('userId') || null,
    willCountry: localStorage.getItem('willCountry') || null,
    companyId: localStorage.getItem('companyId') || null,
    coBrandingUrl: localStorage.getItem('coBrandingUrl') || null,
    coBrandingName: localStorage.getItem('coBrandingName') || null,
    companyOffersFreeWill:
      localStorage.getItem('companyOffersFreeWill') || null,
    bannerTitle: localStorage.getItem('bannerTitle') || null,
    bannerDescription: localStorage.getItem('bannerDescription') || null,
    pendingRedirect: localStorage.getItem('pendingRedirect') || null,
    vatRate: 0.15,
  },
  mutations: {
    authSuccess(
      state,
      { accessToken, refreshToken, testatorId, userId, willCountry, companyId }
    ) {
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.testatorId = testatorId;
      state.userId = userId;
      state.willCountry = willCountry;
      state.companyId = companyId;
    },
    logout(state) {
      state.accessToken = null;
      state.refreshToken = null;
      state.testatorId = null;
      state.userId = null;
      state.willCountry = null;
      state.companyId = null;
      state.pendingRedirect = null;
    },
    loginAs(state, { testatorId, userId, willCountry }) {
      state.testatorId = testatorId;
      state.userId = userId;
      state.willCountry = willCountry;
    },
    coBrandingUrl(state, { url }) {
      state.coBrandingUrl = url;
    },
    coBrandingName(state, { name }) {
      state.coBrandingName = name;
    },
    companyOffersFreeWill(state, { companyOffersFreeWill }) {
      state.companyOffersFreeWill = companyOffersFreeWill;
    },
    bannerTitle(state, { bannerTitle }) {
      state.bannerTitle = bannerTitle;
    },
    bannerDescription(state, { bannerDescription }) {
      state.bannerDescription = bannerDescription;
    },
    setPendingRedirect(state, redirectPath) {
      state.pendingRedirect = redirectPath;
      if (redirectPath) {
        localStorage.setItem('pendingRedirect', redirectPath);
      } else {
        localStorage.removeItem('pendingRedirect');
      }
    },
  },
  actions: {
    login(
      { commit, getters },
      {
        accessToken,
        refreshToken,
        testatorId = getters.testatorId,
        userId = getters.userId,
        willCountry = getters.willCountry,
        companyId,
      }
    ) {
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('testatorId', testatorId);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('userId', userId);
      localStorage.setItem('willCountry', willCountry);
      localStorage.setItem('companyId', companyId);
      commit('authSuccess', {
        accessToken,
        refreshToken,
        testatorId,
        userId,
        willCountry,
        companyId,
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('testatorId');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userId');
        localStorage.removeItem('willCountry');
        localStorage.removeItem('pendingRedirect');
        commit('logout');
        resolve();
      });
    },
    loginAs({ commit }, { testatorId, userId, willCountry }) {
      localStorage.setItem('testatorId', testatorId);
      localStorage.setItem('userId', userId);
      localStorage.setItem('willCountry', willCountry);
      commit('loginAs', { testatorId, userId, willCountry });
    },
    logoutAs({ commit, getters }) {
      const userId = getters.userIdFromToken;
      const testatorId = getters.testatorIdFromToken;
      const willCountry = getters.willCountryFromToken;

      localStorage.setItem('testatorId', testatorId);
      localStorage.setItem('userId', userId);
      localStorage.setItem('willCountry', willCountry);

      commit('loginAs', { testatorId, userId, willCountry });
    },
    setCoBrandingUrl(
      { commit },
      { companyOffersFreeWill, url, name, bannerTitle, bannerDescription }
    ) {
      commit('coBrandingUrl', { url });
      commit('coBrandingName', { name });
      commit('bannerTitle', { bannerTitle });
      commit('bannerDescription', { bannerDescription });
      commit('companyOffersFreeWill', { companyOffersFreeWill });
    },
    setPendingRedirect({ commit }, redirectPath) {
      commit('setPendingRedirect', redirectPath);
    },
    // removed referral redirect action
  },
  getters: {
    isLoggedIn: state => !!state.userId,
    testatorId: state => state.testatorId,
    companyId: state => state.companyId,
    userId: state => state.userId,
    accessToken: state => state.accessToken,
    refreshToken: state => state.refreshToken,
    willCountry: state => state.willCountry,
    companyOffersFreeWill: state => state.companyOffersFreeWill,
    coBrandCompanyUrl: state => {
      return state.coBrandingUrl;
    },
    coBrandCompanyName: state => {
      return state.coBrandingName;
    },
    bannerTitle: state => {
      return state.bannerTitle;
    },
    bannerDescription: state => {
      return state.bannerDescription;
    },
    pendingRedirect: state => {
      return state.pendingRedirect;
    },
    // removed referralRedirect getter
    isAdminLoggedInAsSomeoneElse: (_state, getters) => {
      return getters.isLoggedInAsSomeoneElse && getters.role == 'admin';
    },
    isAdmin: (_state, getters) => {
      return !getters.isLoggedInAsSomeoneElse && getters.role == 'admin';
    },
    isAdvisor: (_state, getters) => {
      return !getters.isLoggedInAsSomeoneElse && getters.role == 'advisor';
    },
    isCompanyAdmin: (_state, getters) => {
      return (
        !getters.isLoggedInAsSomeoneElse && getters.role == 'company_admin'
      );
    },
    isLeadProvider: (_state, getters) => {
      return (
        !getters.isLoggedInAsSomeoneElse && getters.role == 'lead_provider'
      );
    },
    isFiduciaryConsultant: (_state, getters) => {
      return (
        !getters.isLoggedInAsSomeoneElse &&
        getters.role == 'fiduciary_consultant'
      );
    },
    isTestator: (_state, getters) => {
      return !getters.isLoggedInAsSomeoneElse && getters.role == 'testator';
    },
    isCallCenterAgent: (_state, getters) => {
      return (
        !getters.isLoggedInAsSomeoneElse && getters.role == 'call_center_agent'
      );
    },
    isBranchAgent: (_state, getters) => {
      return !getters.isLoggedInAsSomeoneElse && getters.role == 'branch_agent';
    },
    role: state => {
      try {
        return VueJwtDecode.decode(state.accessToken)['role'];
      } catch {
        return null;
      }
    },
    isSppProvider: state => {
      try {
        return VueJwtDecode.decode(state.accessToken)['spp_provider'];
      } catch {
        return null;
      }
    },
    isEnrolmentAdviser: state => {
      try {
        return VueJwtDecode.decode(state.accessToken)['enrolment_adviser'];
      } catch {
        return false;
      }
    },
    isLoggedInAsSomeoneElse: (state, getters) => {
      return (
        getters.testatorIdFromToken &&
        state.testatorId &&
        getters.testatorIdFromToken != state.testatorId
      );
    },
    testatorIdFromToken: state => {
      try {
        return VueJwtDecode.decode(state.accessToken)['testator_id'];
      } catch {
        return null;
      }
    },
    userIdFromToken: state => {
      try {
        return VueJwtDecode.decode(state.accessToken)['user_id'];
      } catch {
        return null;
      }
    },
    willCountryFromToken: state => {
      try {
        return VueJwtDecode.decode(state.accessToken)['will_country'];
      } catch {
        return null;
      }
    },
    vatRate: state => {
      return state.vatRate;
    },
  },
};
